import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button, Form, InputNumber, message, Modal } from 'antd';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { useForm } from 'antd/lib/form/Form';
import { removePartFromWorkOrder } from '../../thunks/parts_equipments_work_orders_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';

const FORM_NAME = 'edit-wo-part-quantity-modal';

const EditWOPartQuantityModal: FC<any> = ({
	workOrderPart,
	removePartFromWO,
	onSuccess,
	onCancel,
	match,
}): React.ReactElement => {
	const [form] = useForm();

	const [removing, setRemoving] = useState(false);

	const existingQuantity = useMemo(
		() => nullSafeGetOrElse('partsQuantity', workOrderPart, 0),
		[workOrderPart]
	);

	const workOrderId = useMemo(() => match.params.id, [match.params.id]);

	const onSubmit = useCallback(
		(values) => {
			setRemoving(true);

			const entity = {
				workOrderId,
				partId: workOrderPart.partId,
				...(nullSafeGet('locationId', workOrderPart) && {
					locationId: workOrderPart.locationId,
				}),
				...(nullSafeGet('partsPerStockLocationId', workOrderPart) && {
					partsPerStockLocationId: workOrderPart.partsPerStockLocationId,
				}),
				quantity: existingQuantity - values.quantity,
			};
			removePartFromWO(entity)
				.then(() => onSuccess())
				.catch((err) => message.error(err))
				.finally(() => setRemoving(false));
		},
		[existingQuantity, onSuccess, workOrderPart, removePartFromWO, workOrderId]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={'Update Part Quantity'}
			closable
			onCancel={onCancel}
			forceRender
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={removing}
				>
					Update Quantity
				</Button>,
			]}
		>
			<Form form={form} id={FORM_NAME} layout="vertical" requiredMark={false} onFinish={onSubmit}>
				<Form.Item
					name="quantity"
					label="Quantity"
					initialValue={existingQuantity}
					rules={[
						{
							type: 'number',
							min: 1,
							message: `You must enter at least one`,
						},
						{
							type: 'number',
							max: existingQuantity,
							message: `You can't enter more than ${existingQuantity}`,
						},
						{
							required: true,
						},
					]}
				>
					<InputNumber style={{ width: '100%' }} min="1" />
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	removePartFromWO: (partData) => dispatch(removePartFromWorkOrder(ROLE_TYPES.SUPPLIER)(partData)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(EditWOPartQuantityModal)
);
